import { useEffect, useMemo, useRef, useState } from 'react';
import "./Features.css";
import pin from "../../../../imagens/pim.webp";


import { VscVerifiedFilled } from "react-icons/vsc";
import { MdClose, MdNavigateNext, MdOutlinePhotoCamera } from "react-icons/md";
import { AiOutlineAudio } from "react-icons/ai";
import { CiMenuKebab, CiViewList } from "react-icons/ci";
import { GrFormPreviousLink } from "react-icons/gr";
import { IoArrowUndoOutline } from "react-icons/io5";
import { PiBatteryFullFill } from "react-icons/pi";

import { BiSolidFilePdf } from "react-icons/bi";
import { CiCalendar } from "react-icons/ci";
import { TbDownload } from "react-icons/tb";
import { TbMoneybag } from "react-icons/tb";
import { TbSquareRoundedCheckFilled } from "react-icons/tb";

import { QRCode } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';


export function Features({ component2Ref, isVisible, component4Ref }) {

    const serviceData = [
        {
            id: 'card-1',
            number: 1,
            title: 'Emissor de NF-e',
            description: 'Nossa equipe do Meu Contador Online, desenvolveu um emissor de Nota Fiscal exclusivo e inovador para clientes ZAP-MEI. Agora, você pode emitir suas notas fiscais diretamente pelo WhatsApp, tornando o processo incrivelmente rápido e fácil.',
            className: 'floating-card-1'
        },
        {
            id: 'card-2',
            number: 2, // O número 2 está no card 2
            title: 'Alerta sobre estouro do faturamento MEI',
            description: 'Evite multas! Monitore em tempo real o limite de R$ 81 mil. Saiba quando e como migrar de forma segura.',
            className: 'floating-card-2'
        },
        {
            id: 'card-3',
            number: 3, // O número 3 está no card 3
            title: 'Recebimento do DAS-N',
            description: 'Receba sua Declaração Anual (DAS-N) pronta e entregue no prazo! Cumpra a obrigação anual do MEI de forma rápida e segura.',
            className: 'floating-card-3'
        },
        {
            id: 'card-4',
            number: 4, // O número 4 está no card 4
            title: 'Recebimento do DAS',
            description: 'Nunca mais esqueça o boleto! Receba seu DAS mensal (Imposto MEI) diretamente no seu WhatsApp, sempre na data certa. Praticidade que cabe no seu bolso.',
            className: 'floating-card-4'
        },
    ];

    const [activeCardId, setActiveCardId] = useState('card-1');

    const [activeChatComponent, setActiveChatComponent] = useState('EmissorNFE');

    // 1. REFERÊNCIAS
    const chatRef2 = useRef(null);
    const qrCodeRef2 = useRef(null);

    const estouroFaturamento = <>
        <p>
            <strong>Fique Atento: Seu MEI Pode Estourar o Faturamento!</strong>
        </p>
        <br />
        <p>
            Crescer é ótimo, mas ultrapassar o limite de faturamento do MEI (R$ 81 mil/ano) sem planejamento pode gerar multas pesadas e burocracia desnecessária!
        </p>
        <br />

        <p>Nosso serviço de Alerta de Estouro de Faturamento monitora seu CNPJ em tempo real e avisa você antes que o limite seja atingido.</p>
        <br />
        <p>
            <ul>
                <li><strong>Sem surpresas:</strong> Saiba exatamente o quanto falta para o limite.</li>
                <li><strong>Planejamento:</strong> Receba a orientação para migrar para ME (Microempresa) de forma suave e legal.</li>
                <li><strong>Tranquilidade:</strong> Evite ser desenquadrado retroativamente e pagar impostos e multas inesperadas.</li>
            </ul>
        </p>

        <br />
        <strong>Não arrisque o futuro do seu negócio. Comece a monitorar agora!</strong>
    </>

    const dasN = <>
        <p>
            <strong>A Declaração Anual que Define o Seu Futuro Fiscal!</strong>
        </p>
        <br />
        <p><strong>DASN-SIMEI: Mais que uma obrigação, um check-up.</strong></p>

        <br />
        <p>É na Declaração Anual (DASN-SIMEI) que o Governo confere se você ultrapassou o limite anual.</p>

        <br />

        <p>
            Um erro ou um faturamento acima do permitido sem a orientação correta pode levar ao desenquadramento retroativo do MEI, gerando multas, juros e impostos mais altos.
        </p>
        <br />

        <ul>
            <li><strong>Zero Erro:</strong> Garantimos a entrega correta do seu faturamento.</li>
            <li><strong>Alerta Imediato: </strong>Se o limite foi estourado, orientamos a migração para ME (Microempresa) de forma legal e planejada.</li>
        </ul>

        <br />

        <strong>Não arrisque sua regularidade. Entregue sua DASN-SIMEI com quem entende.</strong>
    </>

    const boletoDas = <>
        <p><strong>O Boleto DAS no Seu Celular!</strong></p>
        <br />

        <p>
            <strong>DAS-MEI: Chega de perder prazo.</strong>
        </p>

        <br />

        <p>
            Pagar o boleto mensal do MEI (DAS) é essencial para manter seus benefícios do INSS e o CNPJ ativo. Mas a rotina faz a gente esquecer!
        </p>

        <br />

        <p>
            Pensando nisso, enviamos seu DAS diretamente para o seu WhatsApp, garantindo que você pague em dia e evite:
        </p>

        <br />

        <ul>
            <li><strong>Multas e Juros por atraso.</strong></li>
            <li><strong>Bloqueio da emissão de notas fiscais.</strong></li>
        </ul>

        <br />

        <p><strong>Comodidade:</strong> Receba o boleto pronto para pagamento, sem precisar acessar sites.</p>
        <p><strong>Segurança:</strong> Tenha a certeza de que está pagando o valor correto.</p>

        <br />

        <strong>Simplifique sua vida fiscal. Receba seu DAS pelo WhatsApp!</strong>
    </>

    const TEXTOS = {
        'card-1': "A emissão de NF-e (Nota Fiscal Eletrônica) é o processo de gerar um documento fiscal digital que registra a venda de produtos ou serviços.",
        'card-2': estouroFaturamento,
        'card-3': dasN,
        'card-4': boletoDas,



    };

    const pixMessageRef2 = useRef(null);

    const [chatContent, setChatContent] = useState(TEXTOS['card-1']);
    const [mensagemEtapa, setMensagemEtapa] = useState(true);
    const [primeiroPasso, setPrimeiroPasso] = useState(false);
    const [segundoPasso, setSegundoPasso] = useState(false);
    const [isAnimated, setIsAnimated] = useState(false);

    const [autoSimulating2, setAutoSimulating2] = useState(false);
    const [showPixMessage2, setShowPixMessage2] = useState(false);
    const [showQR2, setShowQR2] = useState(false);
    const [showBoletoArquivo] = useState(false);

    const smoothScrollToBottom = () => {
        if (chatRef2.current) {
            chatRef2.current.scrollTop = chatRef2.current.scrollHeight;
        }
    };
    //Esse UseEffect funciona para simular a animação de uma conversa dentro da classe chat-2
    useEffect(() => {
        const isDasComponent = activeChatComponent === 'RecebimentoDASN' || activeChatComponent === 'RecebimentoDAS';

        if (!isDasComponent || !autoSimulating2) {
            return;
        }

        setShowPixMessage2(false);
        setShowQR2(false);

        const timer1 = setTimeout(() => {
            setShowPixMessage2(true);
        }, 1500);

        const timer2 = setTimeout(() => {
            setShowQR2(true);
            setAutoSimulating2(false);
        }, 2900);

        return () => {
            clearTimeout(timer1)
            clearTimeout(timer2)
        }

    }, [autoSimulating2, activeChatComponent]);


    useEffect(() => {
        const rafId = requestAnimationFrame(() => {
            smoothScrollToBottom();
        })
        return () => cancelAnimationFrame(rafId)
    }, [activeChatComponent, showPixMessage2, showQR2, primeiroPasso, segundoPasso]);

    const handleCardClick = (cardId) => {
        setActiveCardId(cardId);
        setChatContent(TEXTOS[cardId]);

        setShowPixMessage2(false);
        setShowQR2(false);
        setAutoSimulating2(false);

        let nextChatComponent = '';

        if (cardId === "card-3") {
            nextChatComponent = 'RecebimentoDASN';
            setAutoSimulating2(true);
        }
        else if (cardId === "card-1") {
            nextChatComponent = 'EmissorNFE';
            setAutoSimulating2(false);
        }
        else if (cardId === "card-2") {
            nextChatComponent = 'FaturamentoMEI';
            setAutoSimulating2(false);
        }
        else if (cardId === "card-4") {
            nextChatComponent = 'RecebimentoDAS';
            setAutoSimulating2(true);
        }
        setActiveChatComponent(nextChatComponent);

        setTimeout(() => {
            smoothScrollToBottom();
        }, 50)
    };

    const FaturamentoMEI = () => {
        return (
            <>
                <div className="message-2 received" style={{ width: "100%" }}>
                    <strong className="style-strong-2">Olá! </strong>
                    <p>Identificamos um extorno no seu faturamento MEI. Por favor, verifique seus registros e confirme se está tudo correto.</p>
                </div>

            </>
        )
    }

    const RecebimentoDASN = () => {
        return (
            <>
                <div className="message-2 received" style={{ width: "100%" }}>
                    <div className="container-box-pdf-2">
                        <div className="icon-pdf-2"><BiSolidFilePdf /></div>
                        <div className="info-pdf-2">
                            <div className="margin-b-5"><label>DAS_N.pdf</label></div>
                            <div className="sub-span-kb-2"><span>289 KB PDF</span></div>
                        </div>
                        <div className="style-down"><TbDownload /></div>
                    </div>

                    <strong className="style-strong-2">Olá Aqui é o PIM, Seu Contador Digital do Meu Contador Online.</strong>
                    <p>Tenho ótimas notícias! Seu documento DAS-N já está disponível para você cliente <strong>Zap-MEI Meu Contador online</strong>,
                        para facilitar sua vida ainda mais, estou te enviando em anexo seu documento.</p>

                    <p><strong>Segue abaixo as informações:</strong></p>

                    <div className="display-flex-chat-2">
                        <div><CiCalendar /></div>
                        <div>Vencimento: 25/10/2025</div>
                    </div>

                    <div className="display-flex-chat-2">
                        <div><TbMoneybag /></div>
                        <div>Valor: R$100,00</div>
                    </div>

                    <div className="display-flex-chat-2">
                        <div><TbSquareRoundedCheckFilled /></div>
                        <div><strong>Importante lembrar: </strong><span>Não é necessário me responder. Até Mais!</span></div>
                    </div>

                    <p>Escolha a melhor forma para o seu pagamento. Até Mais!!!</p>

                    <div>
                        <div
                            className="display-flex-chat-2"
                            style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                        >
                            <div><IoArrowUndoOutline /></div>
                            <div style={{ color: "#007aff" }}>Pix</div>
                        </div>

                        <div
                            className="display-flex-chat-2"
                            style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                        >

                            <div><IoArrowUndoOutline /></div>
                            <div style={{ color: "#007aff" }}>Boleto</div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const RecebimentoDAS = () => {
        return (
            <>
                <div className="message-2 received" style={{ width: "100%" }}>
                    <div className="container-box-pdf-2">
                        <div className="icon-pdf-2"><BiSolidFilePdf /></div>
                        <div className="info-pdf-2">
                            <div className="margin-b-5"><label>DAS_MEI.pdf</label></div>
                            <div className="sub-span-kb-2"><span>289 KB PDF</span></div>
                        </div>
                        <div className="style-down"><TbDownload /></div>
                    </div>

                    <strong className="style-strong-2">Olá Aqui é o PIM, Seu Contador Digital do Meu Contador Online.</strong>
                    <p>Tenho ótimas notícias! Seu documento DAS-MEI já está disponível para você cliente <strong>Zap-MEI Meu Contador online</strong>,
                        para facilitar sua vida ainda mais, estou te enviando em anexo seu documento.</p>

                    <p><strong>Segue abaixo as informações:</strong></p>

                    <div className="display-flex-chat-2">
                        <div><CiCalendar /></div>
                        <div>Vencimento: 25/10/2025</div>
                    </div>

                    <div className="display-flex-chat-2">
                        <div><TbMoneybag /></div>
                        <div>Valor: R$100,00</div>
                    </div>

                    <div className="display-flex-chat-2">
                        <div><TbSquareRoundedCheckFilled /></div>
                        <div><strong>Importante lembrar: </strong><span>Não é necessário me responder. Até Mais!</span></div>
                    </div>

                    <p>Escolha a melhor forma para o seu pagamento. Até Mais!!!</p>

                    <div>
                        <div
                            className="display-flex-chat-2"
                            style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                        >
                            <div><IoArrowUndoOutline /></div>
                            <div style={{ color: "#007aff" }}>Pix</div>
                        </div>

                        <div
                            className="display-flex-chat-2"
                            style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                        >

                            <div><IoArrowUndoOutline /></div>
                            <div style={{ color: "#007aff" }}>Boleto</div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const EmissorNFE = () => {
        const handleEmitirNFSE = () => {
            setMensagemEtapa(false)
            setPrimeiroPasso(true);
        }

        const handleContinuar = () => {
            setMensagemEtapa(false);
            setPrimeiroPasso(false);
            setSegundoPasso(true);
        }

        return (
            <>
                {mensagemEtapa && (
                    <div className="message-2 received" style={{ width: "100%" }}>
                        <strong className="style-strong-2">Tudo certo! </strong>
                        <p>Agora é só seguir os passos para gerar sua nota fiscal. A gente vai te mostrar o que preencher em cada etapa.</p>

                        <p>Pronto? Então é só clicar no botão abaixo e começar agora!</p>

                        <div style={{ textAlign: "center" }}>
                            <div
                                className="display-flex-chat-2"
                                style={{ borderBottom: "1px solid #e5e5e5", cursor: "pointer" }}
                            >

                                <div><CiViewList /></div>
                                <div style={{ color: "#007aff" }} onClick={handleEmitirNFSE}>Emitir NFSE</div>
                            </div>
                        </div>
                    </div>
                )}

                {primeiroPasso && (
                    <div className='modal-etapa'>
                        <div className='etapa-1'>
                            <div style={{ display: "flex", marginBottom: 2, color: "#333" }}>
                                <div className='just-center' onClick={() => {
                                    setPrimeiroPasso(false);
                                    setSegundoPasso(false);
                                    setMensagemEtapa(true);
                                }}><MdClose /></div>
                                <div className='just-center' style={{ fontSize: 14, width: "100%" }}><strong>Emissor de Notas Fiscais MCO</strong></div>
                                <div className='just-center'><CiMenuKebab /></div>
                            </div>

                            <div style={{ display: "flex" }}>
                                <div style={{ borderBottom: "2px solid #007aff", width: "50%", margin: 1, borderRadius: 5 }}></div>
                                <div style={{ borderBottom: "2px solid #333", width: "50%", margin: 1, borderRadius: 5 }}></div>
                            </div>

                            <div style={{ fontSize: 13, color: "#333" }}>
                                <p>Bem-vindo ao sistema de emissão de notas fiscais em 4 passos - ZAP MEI | Meu Contador Online!</p>
                                <span>Vamos começar a emitir sua nota fiscal?</span>

                                <p>Clique em Continuar para prosseguir. Vamos te acompanhar em cada etapa! Para facilitar, tenha em mãos as seguintes informações:</p>

                                <p>1. CNPJ/CPF do tomador (opcional):
                                    Informe o CNPJ ou CPF da empresa ou pessoa que contratou o seu serviço, caso queira incluir essa informação na nota.
                                </p>

                                <p>2. Descrição do serviço:
                                    Escreva um resumo simples e objetivo que descreve o serviço realizado.
                                </p>

                                <p>3. Valor do serviço:
                                    Informe o valor total cobrado pelo serviço.
                                </p>

                                <p>4. Atividade executada:
                                    Escolha a atividade que melhor representa o serviço prestado, conforme o seu cadastro de empresa.
                                </p>


                                <div
                                    className="display-flex-chat-2"
                                    style={{ borderBottom: "1px solid #e5e5e5", cursor: "pointer", marginBottom: 10 }}
                                >
                                    <div style={{ marginBottom: 5 }}><IoArrowUndoOutline /></div>
                                    <div style={{ color: "#007aff", marginBottom: 5 }} onClick={handleContinuar}>Continuar</div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                {segundoPasso && (
                    <div className='modal-etapa'>
                        <div className='etapa-2'>
                            <div style={{ display: "flex", marginBottom: 10, color: "#333" }}>
                                <div className='just-center' onClick={() => {
                                    setSegundoPasso(false);
                                    setMensagemEtapa(false);
                                    setPrimeiroPasso(true);
                                }}><GrFormPreviousLink /></div>
                                <div className='just-center' style={{ fontSize: 14, width: "100%" }}><strong>ZAP MEI - Meu Contador Online</strong></div>
                                <div className='just-center'><CiMenuKebab /></div>
                            </div>

                            <div style={{ display: "flex", marginBottom: 20 }}>
                                <div style={{ borderBottom: "2px solid #007aff", width: "100%", margin: 1, borderRadius: 5 }}></div>
                            </div>

                            <div style={{ fontSize: 14, color: "#333" }}>
                                <div>
                                    <div className='campo-etapa'>CPF/CNPJ DO TOMADOR (opcional)</div>
                                    <div className='text-campo'><span>Digite o CNPJ da empresa que vai receber o seu serviço - Apenas números</span></div>
                                </div>

                                <div>
                                    <div className='campo-maior-etapa'>Descrição do serviço</div>
                                    <div className='text-campo'><span>Escreva um resumo simples e objetivo que descreva o serviço realizado</span></div>
                                </div>

                                <div>
                                    <div className='campo-etapa'>Valor do Serviço</div>
                                    <div className='text-campo'><span>Valor total do serviço prestado no formato brasileiro, com virgula para centados</span></div>
                                </div>



                                <div
                                    className="display-flex-chat-2"
                                    style={{ borderBottom: "1px solid #e5e5e5", cursor: "pointer", marginBottom: 10 }}
                                >   <div style={{ marginBottom: 5 }}><IoArrowUndoOutline /></div>
                                    <div style={{ color: "#007aff", marginBottom: 5 }}>Concluir</div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }

    useEffect(() => {
        if (!isAnimated) {
            const timeout = setTimeout(() => {
                setIsAnimated(true);
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [isAnimated]);

    const [activeCardIdM, setActiveCardIdM] = useState(serviceData[0].id);

    const orderedServiceData = useMemo(() => {
        if (!activeCardIdM || serviceData.length < 3) return serviceData;
        const activeIndex = serviceData.findIndex(card => card.id === activeCardIdM);
        if (activeIndex === -1) return serviceData;
        const n = serviceData.length;

        const prevIndex = (activeIndex - 1 + n) % n;
        const nextIndex = (activeIndex + 1) % n;
        return [
            serviceData[prevIndex],
            serviceData[activeIndex],
            serviceData[nextIndex]
        ];

    }, [activeCardIdM]);

    const handleCardClickCard = (cardId) => {
        setActiveCardIdM(cardId);

        setChatContent(TEXTOS[cardId]);

        if (cardId === "card-1") {
            setActiveChatComponent('EmissorNFE');
        }
        else if (cardId === "card-3") {
            setActiveChatComponent('RecebimentoDASN');
        }
        else if (cardId === "card-2") {
            setActiveChatComponent('FaturamentoMEI');
        }
        else if (cardId === "card-2") {
            setActiveChatComponent('RecebimentoDAS');
        }
    }

    return (
        <>
            <div className='container-features'>
                <div className='width-margin'>
                    <div
                        ref={component2Ref}
                        className={`component-2 ${isVisible ? "show" : ""}`}
                        style={{ position: "relative" }}
                    >
                        <div style={{ textAlign: "center", marginBottom: "30px" }}>
                            <label className='banner-text'>
                                O <span className="title-component-2">MEI</span> <br />
                                não precisa de mais <span style={{ color: "#ff6969" }}>BUROCRACIA. </span>{" "}<br />
                                <span style={{ color: "#5fb75f" }}><label style={{ color: "#fff" }}>Precisa de</label> TEMPO.</span>
                            </label>

                            <div class="section-container">
                                <div class="card-designer">
                                    <div class="numero-badge">X</div>
                                    <div class="icon-style">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                    </div>
                                    <div style={{ textAlign: "-webkit-center" }}>
                                        <h3 class="card-title">Instabilidade no Governo</h3>
                                    </div>
                                    <p class="card-desc">Você entra no site do governo, trava, dá erro, pede certificado e o botão some na hora que você mais precisa.</p>
                                </div>

                                <div class="card-designer">
                                    <div class="numero-badge">X</div>
                                    <div class="icon-style">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                    </div>
                                    <div style={{ textAlign: "-webkit-center" }}>

                                        <h3 class="card-title">Atrasos no DAS</h3>
                                    </div>
                                    <p class="card-desc">Você deixa para depois e acaba pagando o DAS fora do prazo. O resultado? Juros que viram uma bola de neve.</p>
                                </div>

                                <div class="card-designer">
                                    <div class="numero-badge">X</div>
                                    <div class="icon-style">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                                    </div>
                                    <div style={{ textAlign: "-webkit-center" }}>

                                        <h3 class="card-title">Emissão de Notas</h3>
                                    </div>
                                    <p class="card-desc">Você precisa emitir nota "pra ontem" e perde 40 minutos tentando navegar em sistemas lentos e complexos.</p>
                                </div>

                                <div class="card-designer">
                                    <div class="numero-badge">X</div>
                                    <div class="icon-style">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                    </div>
                                    <div style={{ textAlign: "-webkit-center" }}>

                                        <h3 class="card-title">Limite do Faturamento</h3>
                                    </div>
                                    <p class="card-desc">Você não sabe se está perto de estourar o limite do MEI — e infelizmente só descobre quando a situação já complicou.</p>
                                </div>
                            </div>

                            <div style={{ margin: "0 auto", display: "flex", justifyContent: "center"}}>
                                <a href="https://wa.me/5508000420627?text=Ol%C3%A1!%20Quero%20assinar%20o%20ZAP%20MEI%20e%20focar%20no%20meu%20neg%C3%B3cio!"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    id="btn-whatsapp-zapmei"
                                    class="quero-saber"
                                    style={{ textDecoration: 'none', fontWeight: 700 }}>
                                    VER COMO FUNCIONA
                                </a>
                            </div>
                        </div>

                        <div ref={component4Ref} style={{ textAlign: "center", marginBottom: "30px" }}>
                            <label className="banner-text">
                                <span className="title-component-2">Tudo em um só lugar</span> <br />
                                guias e notas fiscais na palma da sua mão pelo{" "}<br />
                                <span style={{ color: "#5fb75f" }}>ZAP-MEI</span>
                            </label>
                        </div>

                        <div className="phone-glow-effect-2 margin-auto-width-100">
                            <div className='flex-block'>
                                <div className="phone-and-cards-container-2">

                                    {/* CARDS PARA TABLETS */}
                                    <div className="slider-container">
                                        <div className="slides-wrapper">
                                            {orderedServiceData.map((profile) => {

                                                const isActive = profile.id === activeCardIdM;

                                                const cardClass = `card-slid ${isActive ? 'active' : ''}`;

                                                return (
                                                    <div
                                                        key={profile.id}
                                                        className={cardClass}
                                                        onClick={() => handleCardClickCard(profile.id)}
                                                    >
                                                        <div className='number-card'>{profile.number}</div>
                                                        <div className="profile-info">
                                                            <span className={`profile-name ${isActive ? 'active' : ''}`}>{profile.title}</span>
                                                            <span className={`profile-title ${isActive ? 'active' : ''}`}>{profile.description}</span>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>


                                    <div id='cards-option' className='cards-slide-container'>
                                        {serviceData.map((card) => {
                                            const isActive = card.id === activeCardId;
                                            const cardClass = `${card.className} card-item ${isActive ? 'card-item-active' : ""}`

                                            return (
                                                <div key={card.id}
                                                    className={cardClass}
                                                    onClick={() => handleCardClick(card.id)}>
                                                    <div className="btn-card">
                                                        <span>{card.number}</span>
                                                    </div>
                                                    <strong>{card.title}</strong>
                                                    <p>{card.description}</p>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <div className="phone-2">
                                        <div className="batery"><PiBatteryFullFill /></div>
                                        <div className="notch-2"></div>
                                        <div className="perfil-pin-2">
                                            <div className="perfil">
                                                <div className="photo-perfil">

                                                    <LazyLoadImage
                                                        className="img-pin"
                                                        src={pin}
                                                        alt="Pin Profile"
                                                        effect="blur"
                                                    />
                                                </div>
                                                <div>
                                                    <div className="nome-perfil">
                                                        <label>Pim</label>
                                                    </div>
                                                    <div className="subtitle">
                                                        <span>Meu Contador Online</span>
                                                        <VscVerifiedFilled className="icon-verifi" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="screen-2">
                                            <div
                                                className="chat-2"
                                                ref={chatRef2}
                                                style={{ marginBottom: 50, overflowY: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}
                                            >

                                                {activeChatComponent === 'EmissorNFE' && <EmissorNFE />}

                                                {activeChatComponent === 'RecebimentoDASN' &&
                                                    <>
                                                        <RecebimentoDASN />

                                                        {showPixMessage2 && (
                                                            <div
                                                                className={`message-2 sent ${showPixMessage2 ? 'show' : ''}`}
                                                                style={{ alignSelf: 'flex-end' }}
                                                                ref={pixMessageRef2}
                                                            >
                                                                <strong>Pix</strong>
                                                            </div>
                                                        )}

                                                        {showBoletoArquivo && (
                                                            <div
                                                                className="message-2 sent show"
                                                                style={{ alignSelf: 'flex-end' }}
                                                            >
                                                                <strong>Boleto</strong>
                                                            </div>
                                                        )}

                                                        {showQR2 && (
                                                            <div
                                                                className={`message-2 received show`}
                                                                style={{ width: "100%", justifyContent: "center", display: "grid" }}
                                                                ref={qrCodeRef2}
                                                            >
                                                                <strong className="style-strong-2" style={{ textAlign: "center" }}>Pronto, agora é só pagar a sua DAS-N por esse pix</strong>
                                                                <div className='card-qr-code'>
                                                                    <QRCode
                                                                        errorLevel="H"
                                                                        value="https://ant.design/pix-ficticio-123"
                                                                        icon={pin}
                                                                    />
                                                                </div>
                                                                <div className="display-flex-chat-2" style={{ flexDirection: 'column', textAlign: 'center' }}>
                                                                    <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>Chave Copia e Cola:</p>
                                                                    <div style={{ wordBreak: 'break-all', fontWeight: 'bold' }}>1198765rgqwd43210wf12345678wf90123wqfqd4567890</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                }

                                                {activeChatComponent === 'FaturamentoMEI' && <FaturamentoMEI />}

                                                {activeChatComponent === "RecebimentoDAS" &&
                                                    <>
                                                        <RecebimentoDAS />

                                                        {showPixMessage2 && (
                                                            <div
                                                                className={`message-2 sent ${showPixMessage2 ? 'show' : ''}`}
                                                                style={{ alignSelf: 'flex-end' }}
                                                                ref={pixMessageRef2}
                                                            >
                                                                <strong>Pix</strong>
                                                            </div>
                                                        )}

                                                        {showBoletoArquivo && (
                                                            <div
                                                                className="message-2 sent show"
                                                                style={{ alignSelf: 'flex-end' }}
                                                            >
                                                                <strong>Boleto</strong>
                                                            </div>
                                                        )}

                                                        {showQR2 && (
                                                            <div
                                                                className={`message-2 received show`}
                                                                style={{ width: "100%", justifyContent: "center", display: "grid" }}
                                                                ref={qrCodeRef2}
                                                            >
                                                                <strong className="style-strong-2" style={{ textAlign: "center" }}>Pronto, agora é só pagar a sua DAS por esse pix</strong>
                                                                <div className='card-qr-code'>
                                                                    <QRCode
                                                                        errorLevel="H"
                                                                        value="https://ant.design/pix-ficticio-123"
                                                                        icon={pin}
                                                                    />
                                                                </div>
                                                                <div className="display-flex-chat-2" style={{ flexDirection: 'column', textAlign: 'center' }}>
                                                                    <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>Chave Copia e Cola:</p>
                                                                    <div style={{ wordBreak: 'break-all', fontWeight: 'bold' }}>1198765rgqwd43210wf12345678wf90123wqfqd4567890</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                }

                                            </div>

                                            <div className="input-phone-2">
                                                <div className="icon-plus-wrapper-2">+</div>
                                                <div className="chat-input-2"></div>
                                                <div className="icon-mic-wrapper-2">
                                                    <div className="icon-mic-2" style={{ marginLeft: 5 }}><MdOutlinePhotoCamera /></div>
                                                    <div className="icon-mic-2"><AiOutlineAudio /></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </div>


                                


                                <div className="data-card-container">

                                    <div className="card-header-visual">
                                        <div className="chat-bubble bubble-1">
                                            <p>{chatContent}</p>
                                        </div>
                                        <div className="visual-circle-bg"></div>
                                        <div className="visual-icon-placeholder">
                                            <LazyLoadImage
                                                style={{ width: "100%" }}
                                                src={pin}
                                                alt="Pin Profile"
                                                effect="blur"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div style={{ margin: "0 auto", display: "flex", justifyContent: "center", marginTop: 60}}>
                                <a href="https://wa.me/5508000420627?text=Ol%C3%A1!%20Quero%20assinar%20o%20ZAP%20MEI%20e%20focar%20no%20meu%20neg%C3%B3cio!"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    id="btn-whatsapp-zapmei"
                                    class="quero-saber"
                                    style={{ textDecoration: 'none', fontWeight: 700 }}>
                                    QUERO O ZAP-MEI
                                </a>
                            </div>

                    </div>
                </div>
            </div>
        </>
    );
}